import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { setUserDetails } from "../redux/userSlice";

export const useAccessToken = () => {
    const { instance, accounts } = useMsal();
    const dispatch = useDispatch();
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        const fetchToken = async () => {
            if (accounts?.length) {
                const account = instance?.getAllAccounts()[0];
                instance?.setActiveAccount(account);
                const tokenRequest = {
                    scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
                };
                try {
                    const response = await instance?.acquireTokenSilent(tokenRequest);
                    if (response?.accessToken) {
                        setAccessToken(response.accessToken);
                        const decoded = jwtDecode(response.accessToken);
                        dispatch(
                            setUserDetails({
                                email: decoded.unique_name,
                                name: `${decoded.given_name || ""} ${decoded.family_name || ""}`,
                            })
                        );
                    }
                } catch (error) {
                    console.error("Error acquiring token:", error);
                }
            } else {
                console.log("No accounts exist to get access token");
            }
        };

        fetchToken();
    }, [instance, accounts, dispatch]);

    return accessToken; // Now this returns the token synchronously
};
